import api from './axios'

export async function extractMenu(files) {
  if (!files?.length) throw new Error('Aucun fichier sélectionné')

  const form = new FormData()
  files.forEach((f) => form.append('files[]', f))

  try {
    const { data } = await api.post('/menu-import/extract', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 200000,
    })
    if (!data?.data) throw new Error('Réponse API invalide : données manquantes')
    return data.data
  } catch (err) {
    const d = err?.response?.data
    console.error('Menu import error:', err?.response?.status, d)
    const validation = d?.errors ? Object.values(d.errors).flat().join(' • ') : ''
    throw new Error(
      validation || d?.message || d?.error || err.message || "Erreur lors de l'import"
    )
  }
}

// Téléverse une photo choisie par l'utilisateur. Retourne l'URL de l'image.
export async function uploadDishImage(file) {
  const form = new FormData()
  form.append('image', file)
  try {
    const { data } = await api.post('/menu-import/upload-image', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    })
    if (!data?.data?.url) throw new Error("Réponse API invalide : pas d'image")
    return data.data.url
  } catch (err) {
    const d = err?.response?.data
    const validation = d?.errors ? Object.values(d.errors).flat().join(' • ') : ''
    throw new Error(validation || d?.message || err.message || "Erreur d'envoi de la photo")
  }
}

// Génère une photo pour un plat. Retourne l'URL de l'image.
export async function generateDishImage({ name, description, category }) {
  try {
    const { data } = await api.post(
      '/menu-import/generate-image',
      { name, description: description || undefined, category: category || undefined },
      { timeout: 120000 }
    )
    if (!data?.data?.url) throw new Error("Réponse API invalide : pas d'image")
    return data.data.url
  } catch (err) {
    const d = err?.response?.data
    console.error('Dish image error:', err?.response?.status, d)
    const validation = d?.errors ? Object.values(d.errors).flat().join(' • ') : ''
    throw new Error(validation || d?.message || err.message || "Erreur de génération d'image")
  }
}